// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from "jquery";
import "./webcommitment";
import "./filter";

$(document).ready(function(){

  $('.form-submit-wrapper__trigger').click(function(){
    $('#customer_login').removeClass('is-active');
    $('#customer_register').addClass('is-active');
  });

  $(".pre-header__woocommerce-nav, .pre-header__search-and-cart__search").hover(function(){
    $('.pre-header-overlay').addClass('is-active');
  }, function(){
    $('.pre-header-overlay').removeClass('is-active');
  });

  $(".menu-shop > .menu-item-has-children").hover(function(){
    $('.pre-header-overlay').addClass('is-active');
  }, function(){
    $('.pre-header-overlay').removeClass('is-active');
  });

  $('.main-menu__container-mobile .menu-item-has-children > a').on('click',function(e){
    e.preventDefault();
    var tag = $(this).parent('li').attr('value');
    var back_link="#layer"+tag;
    $('.menu-item--back').attr('href',back_link);
    $('.menu-item--back').attr('value',tag);
    $(this).siblings($("#layer"+tag)).removeClass('hide');
    $(this).siblings($("#layer"+tag)).toggleClass('show-menu');
  });

  $('.menu-item--back').on('click',function(e){
    e.preventDefault();
    var tag = $(this).attr('href');
    var val= $(this).attr('value');
    $(this).parent().parent($(tag)).removeClass('show-menu');
    $(this).parent().parent($(tag)).addClass('hide');
    $(tag).addClass('test');
    var back_link="#layer"+(val-1);
    $('.menu-item--back').attr('href',back_link);
    $('.menu-item--back').attr('value',val-1);
  });


  $('.product-categories > .cat-item > a').one('click',function(e){
    if($(this).parent('.cat-item').find('ul.children').length !== 0){
      e.preventDefault();
      $(this).parent('.cat-item').children('ul.children').addClass('active');
    }
  })

});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js